import { render } from "./CustomerDetails.vue?vue&type=template&id=9517b860&ts=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__